module.exports = __webpack_public_path__ + "static/media/clean-ginssen-icon-03.cc27e6fe.png";